const sortProjects = projects =>
  [...(projects || [])].sort((a, b) => {
    const aPrimaryDate = a?.project_start || a?.created_at || '';
    const bPrimaryDate = b?.project_start || b?.created_at || '';
    if (aPrimaryDate !== bPrimaryDate) {
      return bPrimaryDate.localeCompare(aPrimaryDate);
    }
    const aCreatedAt = a?.created_at || '';
    const bCreatedAt = b?.created_at || '';
    if (aCreatedAt !== bCreatedAt) {
      return bCreatedAt.localeCompare(aCreatedAt);
    }
    return `${a?.name || ''}`.localeCompare(`${b?.name || ''}`);
  });

const getSelectedClientObject = state => {
  const selectedClientReference = state.savedClients?.selectedClientReference || {};
  const assignedClients = state.researcherClients || [];
  const otherSelectedClients = state.savedClients?.otherSelectedClients || [];

  if (selectedClientReference?.client) {
    return (
      assignedClients.find(client => `${client.id}` === `${selectedClientReference.client}`) ||
      otherSelectedClients.find(client => `${client.id}` === `${selectedClientReference.client}`) ||
      null
    );
  }

  if (selectedClientReference?.member) {
    return otherSelectedClients.find(client => `${client.member_id}` === `${selectedClientReference.member}`) || null;
  }

  return null;
};

export default {
  researchNotesState(state) {
    return state.notes;
  },
  researchNotesMetaState(state) {
    return state.notesMeta;
  },
  researchNotesFilterOptionsByScopeState(state) {
    return state.notesFilterOptionsByScope || {};
  },
  researchResearcherClientsState(state) {
    return state.researcherClients || [];
  },
  researchSharepointFilesByClientState(state) {
    return state.sharepointFilesByClient || {};
  },
  researchSharepointFilesLoadingByClientState(state) {
    return state.sharepointFilesLoadingByClient || {};
  },
  researchSharepointFilesErrorByClientState(state) {
    return state.sharepointFilesErrorByClient || {};
  },
  researchArchiveFilesByClientState(state) {
    return state.archiveFilesByClient || {};
  },
  researchArchiveFilesLoadingByClientState(state) {
    return state.archiveFilesLoadingByClient || {};
  },
  researchArchiveFilesErrorByClientState(state) {
    return state.archiveFilesErrorByClient || {};
  },
  researchDisplayedProjectsState(state, getters) {
    const selectedClientReference = getters.researchSavedClientsState?.selectedClientReference || {};
    const selectedClientObject = getSelectedClientObject(state);
    const projectsById = state.researcherProjectsById || {};

    if (!selectedClientReference?.client && !selectedClientReference?.member) {
      return sortProjects(Object.values(projectsById || {}));
    }

    const matchingClient = selectedClientReference?.client
      ? getters.researchResearcherClientsState.find(client => `${client.id}` === `${selectedClientReference.client}`)
      : null;
    if (matchingClient) {
      const projectIds = matchingClient.projects || [];
      return sortProjects(projectIds.map(projectId => projectsById[projectId]).filter(Boolean));
    }

    const projects = selectedClientObject?.projects || [];
    return sortProjects(projects.filter(project => project?.id));
  },
  researchMembersUpdatingState(state) {
    return state.researchMembersUpdating;
  },
  researchNotesLoadingState(state) {
    return state.notesLoading;
  },
  researchNoteState(state) {
    return state.note || {};
  },
  researchNoteLoadingState(state) {
    return state.noteLoading;
  },
  researchNoteUpdateLoadingState(state) {
    return state.noteUpdateLoading;
  },
  researchUnifiedSearchListState(state) {
    return state.unifiedSearchList || [];
  },
  researchUnifiedSearchMetaState(state) {
    return state.unifiedSearchMeta || {};
  },
  researchUnifiedSearchLoadingState(state) {
    return state.unifiedSearchLoading;
  },
  researchSavedClientsState(state) {
    return state.savedClients || {};
  },
};
